import React from "react";
import TabsBase from './Base/Base'
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
class Tap extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            params:props.msg
        }
    }
    
    render() {
        const params = this.state
        return (
            <div>
                <TabsBase {...params}/>
            </div>
        )
    }
}
  export default (withRouter(Tap))
